import AlertPage from "components/common/AlertPage";
import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { Alert } from "react-ionicons";

const AccountConfirmation = () => {
  return (
    <div className="page-content">
      <Helmet>
        <title>Inscription confirmée</title>
        <meta name="description" content="Votre inscription a été confirmée avec succès." />
        <meta property="og:title" content="Inscription confirmée" />
        <meta property="og:description" content="Votre inscription a été confirmée avec succès." />
        <meta property="og:type" content="website" />
      </Helmet>
      <AlertPage title={"Inscription enregistrée"} description={"Votre inscription a bien été enregistrée."} />
    </div>
  );
};

export default AccountConfirmation;
